import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectsReducerCreator } from '../types';

const setSelectedProjectGroupReducer = (create: ProjectsReducerCreator) => {
  return create.reducer((state, action: PayloadAction<string>) => {
    state.selectedProjectGroup = action.payload;
  });
};

export default setSelectedProjectGroupReducer;
